require('./topmenu.less');

jQuery(function() {
    $('.js-topmenu-item-dropdown').hover(
        function() {
            var $this = $(this);
            var $dropdown = $this.find('.topmenu__dropdown');

            if ($dropdown.length > 0) {
                $dropdown.stop().slideDown(200);
            }
        },
        function() {
            var $this = $(this);
            var $dropdown = $this.find('.topmenu__dropdown');

            if ($dropdown.length > 0) {
                $dropdown.stop().slideUp(200);
            }
        }
    );
});



// WEBPACK FOOTER //
// ./blocks/topmenu/topmenu.js